export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR'
export function setGlobalError(error) {
  return {
    type: SET_GLOBAL_ERROR,
    payload: error
  };
}
